module.exports = __webpack_public_path__ + "static/media/kamil-karpus.5aed84ac.jpg";